// Palette
import palette from '../palette';

export default {
  root: {
    height: '48px',
    fontWeight: 500,
    textTransform: 'none',
    fontSize: '14px',
    lineHeight: '19px',
    letterSpacing: '1.25px',
    '@media (min-width: 960px)': {
      minWidth: '100px',
    },
    '&$selected': {
      fontWeight: 500,
      color: palette.primary.main,
    },
  },
  textColorPrimary: {
    color: palette.text.secondary,
    '&$selected': {
      color: palette.primary.main,
    },
  },
};
